<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">

                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'ENABLED')" />
                        </div>
                        <!-- <div class="col mb-3">
                            <TheSelect title="Đồng bộ từ IOC tỉnh" :options="category_ENABLED"
                                :initialValue="sValue_IOCENABLED" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'IOCENABLED')" />
                        </div> -->


                        <div class="col mb-3">
                            <TheInputText title="Tên trường" placeholder="Tìm theo tên trường"
                                :initialValue="modelSearch.tenTruong" v-model="modelSearch.tenTruong" :isRequire=false
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Trường ID" placeholder="Tìm theo trường ID"
                                :initialValue="modelSearch.truongId" v-model="modelSearch.truongId" :isRequire=false
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="VEMIS ID" placeholder="Tìm theo VEMIS ID"
                                :initialValue="modelSearch.truongId" v-model="modelSearch.vemisId" :isRequire=false
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phường/Xã" :options="category_PHUONGXA"
                                :initialValue="modelSearch.phuongXaId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'PHUONGXA')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Mức trường chuẩn" :options="category_MUCTRUONGCHUANGD"
                                :initialValue="modelSearch.mucTruongchuanId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'MUCTRUONGCHUAN')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Quy mô trường chuẩn" :options="category_QUYMOTRUONGCHUANGD"
                                :initialValue="modelSearch.quymoTruongchuanId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'QUYMOTRUONGCHUAN')" />
                        </div>

                        <div class="col mb-3">
                            <TheSelect title="Phân loại trường chuẩn" :options="category_PHANLOAITRUONGCHUAN"
                                :initialValue="modelSearch.phanloaiTruongchuanId" :isMultiple="false"
                                :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => onSelectSearchChange(v, 'PHANLOAITRUONG')" />
                        </div>

                        <div class="col mb-3">
                            <TheSelect title="Công lập" :options="category_CONGLAP" :initialValue="modelSearch.congLap"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => onSelectSearchChange(v, 'CONGLAP')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="sType_List == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" title="Xem bản đồ" @click="openMap()">
                            <i class="far fa-map" style="color: #28a745;"></i>
                        </button>
                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapCurrentList')" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == typeDataList.CURRENT_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapDeletedList')" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.RESTORE)" :title="$t('buttons.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('buttons.restore') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE_TEMP)"
                                        :title="$t('buttons.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.delete')
                                        }}</a>
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE)"
                                        :title="$t('buttons.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.deleteReal')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.ON_ENABLED)"
                                        :title="$t('buttons.onEnabled')"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.onEnabled') }}</a>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.OFF_ENABLED)"
                                        :title="$t('buttons.offEnabled')"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.offEnabled') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <!-- <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.ON_IOC_ENABLED)" title="Bật hiển thị trên Cổng"><i
                                            class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                            {{ $t('buttons.onIOCEnabled') }}</a>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red" href="#"
                                        @click="confirmList(navigateCode.OFF_IOC_ENABLED)" title="Ẩn hiển thị trên App"><i
                                            class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                            {{ $t('buttons.offIOCEnabled') }}</a> -->

                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id"
                                        class="dropdown-item text-green" href="#" @click="exportExcel()"
                                        :title="$t('buttons.exportExcel')">
                                        <i class="fas fa-file-export"></i>&nbsp;&nbsp;{{ $t('buttons.exportExcel')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id"
                                        class="dropdown-item text-green" href="#" @click="showImportModal()"
                                        :title="$t('buttons.importExcel')">
                                        <i class="fas fa-file-import"></i>&nbsp;&nbsp;{{ $t('buttons.importExcel')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, navigateCode.CREATE)"
                            v-bind:title="$t('buttons.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col10">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('truongchuanQuocgiaId')">
                                        ID
                                        <span v-if="sortBy == 'truongchuanQuocgiaId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col100 cursor" @click="handleSortChange('tenTruong')">
                                        Tên trường
                                        <span v-if="sortBy == 'tenTruong'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenPhuongXa')">
                                        Phường/Xã
                                        <span v-if="sortBy == 'tenPhuongXa'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenMucTruongchuan')">
                                        Mức trường chuẩn
                                        <span v-if="sortBy == 'tenMucTruongchuan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenQuymoTruongchuan')">
                                        Quy mô trường chuẩn
                                        <span v-if="sortBy == 'tenQuymoTruongchuan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenPhanloaiTruongchuan')">
                                        Phân loại
                                        <span v-if="sortBy == 'tenPhanloaiTruongchuan'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('congLap')">
                                        Công lập
                                        <span v-if="sortBy == 'congLap'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Trường ID</th>
                                    <th class="col50">Vemis ID</th>

                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <!-- <th class="col50">Đồng bộ từ IOC tỉnh</th> -->
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.truongchuanQuocgiaId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList_Navigate.csList.includes(item.truongchuanQuocgiaId))"
                                            aria-hidden="true" class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.truongchuanQuocgiaId }}</td>
                                    <td>{{ item.tenTruong }}</td>
                                    <td>{{ item.tenPhuongXa }}</td>
                                    <td>{{ item.tenMucTruongchuan }}</td>
                                    <td>{{ item.tenQuymoTruongchuan }}</td>
                                    <td>{{ item.tenPhanloaiTruongchuan }}</td>
                                    <td v-if="item.congLap == 1">Công lập</td>
                                    <td v-else-if="item.congLap == 0">Tư thục</td>
                                    <td v-else></td>
                                    <td>{{ item.truongId }}</td>
                                    <td>{{ item.vemisId }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == typeDataList.DELETED_LIST.id"
                                                :id="'item' + item.truongchuanQuocgiaId" v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.truongchuanQuocgiaId"></label>
                                        </div>
                                    </td>
                                    <!-- <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == typeDataList.DELETED_LIST.id" :id="'itemIOC' + item.truongchuanQuocgiaId"
                                                v-model="item.iocEnabledDisplay"
                                                v-on:click="openConfirmIOCEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'itemIOC' + item.truongchuanQuocgiaId"></label>
                                        </div>
                                    </td> -->
                                    <td>
                                        <button v-if="sType_List == typeDataList.CURRENT_LIST.id" type="button"
                                            size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="openDetailMap(item.truongchuanQuocgiaId)" title="Xem vị trí">
                                            <i class="fas fa-map-marked-alt" style="color: #28a745;"></i>
                                        </button>&nbsp;
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, navigateCode.DETAIL)" :title="$t('labels.detail')">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == typeDataList.CURRENT_LIST.id">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, navigateCode.UPDATE)"
                                                :title="$t('labels.update')">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, sType_List == typeDataList.DELETED_LIST.id ? navigateCode.DELETE : navigateCode.DELETE_TEMP)"
                                            :title="$t('labels.delete')">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;

                                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button"
                                            size="sm" class="btn btn-outline-warning btn-xs"
                                            v-on:click="detail(item, navigateCode.RESTORE)"
                                            :title="$t('labels.restore')">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
        <loading :active="!displayChangeSubmit" class="text-center" color="#000000" loader="spinner"></loading>
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary">{{ title }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="hideModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="max-height: 600px; overflow-y: auto;">
                    <div class="row">
                        <div class="col-12">
                            <div>
                                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin trường:</b>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Tên trường" placeholder="Nhập tên trường"
                                :initialValue="model.tenTruong" v-model="model.tenTruong" :error="errors.tenTruong"
                                :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <TheInputText title="Trường ID" placeholder="Nhập trường ID" :initialValue="model.truongId"
                                v-model="model.truongId" :error="errors.truongId" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheInputText title="Vemis ID" placeholder="Nhập vemis ID" :initialValue="model.vemisId"
                                v-model="model.vemisId" :error="errors.vemisId" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSelect title="Công lập" :options="category_CONGLAP" :initialValue="model.congLap"
                                :error="errors.congLap" :isMultiple="false" :isReadOnly="isReadOnly"
                                :isAllowClear="true" :isRequire="false" @onChange="(e) => { model.congLap = e }"
                                :key="tempKey" />
                        </div>
                    </div>



                    <div class="row">
                        <div class="col-md-4">
                            <TheSelect title="Mức trường chuẩn" :options="category_MUCTRUONGCHUANGD"
                                :initialValue="model.mucTruongchuanId" :error="errors.mucTruongchuanId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.mucTruongchuanId = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSelect title="Quy mô" :options="category_QUYMOTRUONGCHUANGD"
                                :initialValue="model.quymoTruongchuanId" :error="errors.quymoTruongchuanId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.quymoTruongchuanId = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSelect title="Phân loại trường" :options="category_PHANLOAITRUONGCHUAN"
                                :initialValue="model.phanloaiTruongchuanId" :error="errors.phanloaiTruongchuanId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.phanloaiTruongchuanId = e }" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <TheInputText title="Số lớp" placeholder="Nhập số lớp" :initialValue="model.soluongLop"
                                v-model="model.soluongLop" :error="errors.soluongLop" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số giáo viên" placeholder="Nhập số lớp"
                                :initialValue="model.soluongGiaovien" v-model="model.soluongGiaovien"
                                :error="errors.soluongGiaovien" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số học sinh" placeholder="Nhập số HS"
                                :initialValue="model.soluongHocsinh" v-model="model.soluongHocsinh"
                                :error="errors.soluongHocsinh" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Số HS đã định danh" placeholder="Nhập số HS định danh"
                                :initialValue="model.soluongHocsinhNhapsodinhdanh"
                                v-model="model.soluongHocsinhNhapsodinhdanh"
                                :error="errors.soluongHocsinhNhapsodinhdanh" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <TheYearPicker title="Năm công nhận" placeholder="Nhập năm công nhận"
                                :initialValue="model.namCongNhan" v-model="model.namCongNhan"
                                :error="errors.namCongNhan" :isReadOnly="isReadOnly" :isRequire="false" minYear="1975"
                                :maxYear="new Date().getFullYear()" :key="tempKey"
                                @onChange="(e) => { model.namCongNhan = e }" />
                        </div>
                        <div class="col-md-4">
                            <TheYearPicker title="Năm sát nhập" placeholder="Nhập năm sát nhập"
                                :initialValue="model.namSatNhap" v-model="model.namSatNhap" :error="errors.namSatNhap"
                                :isReadOnly="isReadOnly" :isRequire="false" minYear="1975"
                                :maxYear="new Date().getFullYear()" :key="tempKey"
                                @onChange="(e) => { model.namSatNhap = e }" />
                        </div>
                        <div class="col-md-4">
                            <TheYearPicker title="Năm thành lập" placeholder="Nhập năm thành lập"
                                :initialValue="model.namThanhLap" v-model="model.namThanhLap"
                                :error="errors.namThanhLap" :isReadOnly="isReadOnly" :isRequire="false" minYear="1975"
                                :maxYear="new Date().getFullYear()" :key="tempKey"
                                @onChange="(e) => { model.namThanhLap = e }" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8">
                            <TheInputText title="Hiệu trưởng" placeholder="Nhập hiệu trưởng"
                                :initialValue="model.hieuTruong" v-model="model.hieuTruong" :error="errors.hieuTruong"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheInputText title="Số điện thoại hiệu trưởng" placeholder="Nhập SĐT hiệu trưởng"
                                :initialValue="model.sdtHieuTruong" v-model="model.sdtHieuTruong"
                                :error="errors.sdtHieuTruong" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <TheSelect title="Phường xã" :options="category_PHUONGXA" :initialValue="model.phuongXaId"
                                :error="errors.phuongXaId" :isMultiple="false" :isReadOnly="isReadOnly"
                                :isAllowClear="true" :isRequire="true" @onChange="(e) => { model.phuongXaId = e }"
                                :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="GPS Long" placeholder="Nhập GPS Long" :initialValue="model.gpsLong"
                                v-model="model.gpsLong" :error="errors.gpsLong" :isReadOnly="isReadOnly"
                                :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="GPS Lat" placeholder="Nhập GPS Lat" :initialValue="model.gpsLat"
                                v-model="model.gpsLat" :error="errors.gpsLat" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheGetLocationButton v-model:modelValueLat="model.gpsLat"
                                v-model:modelValueLong="model.gpsLong" />
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                                v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="true" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Giới thiệu" placeholder="Nhập giới thiệu"
                                :initialValue="model.gioiThieu" v-model="model.gioiThieu" :error="errors.gioiThieu"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true" :isSummerNote="true"
                                :key="tempKey" />
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-12">
                            <div>
                                <hr />
                                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin khác:</b>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Hiển thị trên cổng</label>
                                </div>
                                <div class="col-md-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="enabled-checkbox"
                                            v-model="model.enabledDisplay" :disabled="isReadOnly">
                                        <label class="custom-control-label" for="enabled-checkbox"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt"
                                v-model="model.stt" :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <!-- <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label>Đồng bộ từ IOC tỉnh</label>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                    id="ioc-enabled-checkbox" v-model="model.iocEnabledDisplay"
                                                    :disabled="isReadOnly">
                                                <label class="custom-control-label" for="ioc-enabled-checkbox"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                    </div>

                    <div class="row">
                        <TheCustomFilePicker ref="filePicker" title="&nbsp;&nbsp;File hình ảnh"
                            :initialValue="filesUpload" error="" :isReadOnly="isReadOnly" :isRequire="false"
                            :isMultiple="false" @onChange="(files) => { filesUpload = files }"
                            :acceptFile="acceptImageType" :key="tempKey" />
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left"
                        @click="hideModal()">&nbsp;Đóng</button>

                    <button v-if="displayChangeSubmit" type="button" class="pull-right" :class="styleButton"
                        @click="onSubmit();">&nbsp;{{ title }}</button>
                </div>
            </div>

        </div>
    </div>

    <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-success">{{ modelRec.tenTruong }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="modelRec && modelRec.hinhAnh">
                        <div class="container mt-3 mb-3 p-1 d-flex justify-content-center">
                            <div class=" image d-flex flex-column justify-content-center align-items-center">
                                <img :src="modelRec.linkHinhAnh" height="150" />
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="modelRec">
                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <div>
                                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin trường:</b>
                                </p>
                            </div>
                        </div>
                        <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                            <p class="text-sm">ID:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.truongchuanQuocgiaId
                                    }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Trường ID:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.truongId }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Vemis ID:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.vemisId }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Phường/xã:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhuongXa }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Công lập:
                                <b class="d-block" v-if="modelRec.congLap == 1">&nbsp;&nbsp;&nbsp;Công
                                    lập&nbsp;</b>
                                <b class="d-block" v-else-if="modelRec.congLap == 0">&nbsp;&nbsp;&nbsp;Tư
                                    thục&nbsp;</b>
                                <b class="d-block" v-else>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                            </p>
                            <p class="text-sm">Phân loại:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhanloaiTruongchuan
                                    }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Số lượng lớp:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soluongLop }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Số lượng giáo viên:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soluongGiaovien }}&nbsp;</b>
                            </p>

                            <p class="text-sm">Số lượng học sinh:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soluongHocsinh }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Số lượng học sinh đã nhập định danh:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soluongHocsinhNhapsodinhdanh
                                    }}&nbsp;</b>
                            </p>

                        </div>
                        <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                            <p class="text-sm">Mức trường chuẩn:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenMucTruongchuan }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Quy mô trường chuẩn:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenQuymoTruongchuan
                                    }}&nbsp;</b>
                            </p>

                            <p class="text-sm">Năm thành lập:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.namThanhLap }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Năm sát nhập:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.namSatNhap }}&nbsp;</b>
                            </p>

                            <p class="text-sm">Năm công nhận:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.namCongNhan }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Hiệu trưởng:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.hieuTruong }}&nbsp;</b>
                            </p>
                            <p class="text-sm">Số điện thoại hiệu trưởng:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.sdtHieuTruong }}&nbsp;</b>
                            </p>

                            <p class="text-sm">GPS Long:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.gpsLong }}&nbsp;</b>
                            </p>
                            <p class="text-sm">GPS Lat:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.gpsLat }}&nbsp;</b>
                            </p>


                        </div>

                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <p class="text-sm">Giới thiệu:
                                <b class="d-block" id="gioiThieu_Detail"></b>
                            </p>

                            <p class="text-sm">Ghi chú:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                            </p>
                        </div>
                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <div>
                                <hr />
                                <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin khác:</b>
                                </p>
                            </div>
                        </div>
                        <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                            <p class="text-sm">STT:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                            </p>


                            <p class="text-sm">Hiển thị trên cổng:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                                    }}&nbsp;</b>
                            </p>

                        </div>
                        <!-- <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">IOC ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.iocId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">IOC ngày cập nhật:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.iocDateUpdated }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đồng bộ từ IOC tỉnh:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.iocEnabled ? "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>
                                </div> -->

                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
        <TheConfirmDialog :title="csList_MapModel.title" :confirmLabelButton="csList_MapModel.confirmLabelButton"
            :onClose="csList_MapModel.onClose" :onSubmit="csList_MapModel.onSubmit"
            :modalContent=csList_MapModel.modalContent></TheConfirmDialog>
    </div>

    <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheCheckboxConfirmDialog :title="csListEnabled_MapModel.title"
            :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton" :onClose="csListEnabled_MapModel.onClose"
            :onSubmit="csListEnabled_MapModel.onSubmit" :modalContent=csListEnabled_MapModel.modalContent
            v-model="checkEnable_Memo" :key="tempKey" :submitArgs="csListEnabled_MapModel.submitArgs">
        </TheCheckboxConfirmDialog>
    </div>

    <!-- <div class="modal fade" id="IOCenabledConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheCheckboxConfirmDialog :title="csListEnabled_MapModel.title"
            :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton" :onClose="csListEnabled_MapModel.onClose"
            :onSubmit="csListEnabled_MapModel.onSubmit" :modalContent=csListEnabled_MapModel.modalContent
            v-model="checkEnable_Memo" :key="tempKey" :submitArgs="csListEnabled_MapModel.submitArgs">
        </TheCheckboxConfirmDialog>
    </div> -->

    <!-- POP UP IMPORT EXCEL  -->
    <div class="modal fade" id="importModal" data-keyboard="false" data-backdrop="static">
        <TheGetFileImportDialog :title="import_GetFileModel.title"
            :confirmLabelButton="import_GetFileModel.confirmLabelButton" :onClose="import_GetFileModel.onClose"
            :onSubmit="import_GetFileModel.onSubmit" :filename="import_GetFileModel.filename"
            :acceptFile="import_GetFileModel.acceptFile" v-model="import_GetFileModel.filesImport">
        </TheGetFileImportDialog>
    </div>

    <div class="modal fade" id="importConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheDataImportShow :title="import_MapModel.title" :confirmLabelButton="import_MapModel.confirmLabelButton"
            :onClose="import_MapModel.onClose" :onSubmit="import_MapModel.onSubmit"
            :displaySubmit="import_MapModel.displaySubmit" :dataTitle="import_MapModel.dataTitle"
            :dataImport="import_MapModel.dataImport" :key="tempKey">
        </TheDataImportShow>
    </div>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import objectDefaultValue from '@/config/object.env'
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import { read, utils, writeFileXLSX } from 'xlsx';
import axios from 'axios';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheYearPicker from '@/components/shareComponents/TheYearPicker.vue';
// import TheInputTextSelect from '@/components/shareComponents/TheInputTextSelect.vue';
import TheCustomFilePicker from '@/components/shareComponents/TheCustomFilePicker.vue';
import TheFilePicker from '@/components/shareComponents/TheFilePicker.vue';
import TheConfirmDialog from '@/components/shareComponents/TheConfirmDialog.vue'
import TheCheckboxConfirmDialog from '@/components/shareComponents/TheCheckboxConfirmDialog.vue'
import TheDataImportShow from '@/components/shareComponents/import/TheDataImportShow.vue'
import TheGetLocationButton from '@/components/shareComponents/map/TheGetLocationButton.vue'
import TheGetFileImportDialog from '@/components/shareComponents/import/TheGetFileImportDialog.vue'

import { tableInteractiveModel } from '@/models/general/tableInteractive.model'
import { truongQGGDModel } from '@/models/giaoduc/caphockhac/truongQGGD.model'

export default {
    name: "TruongQGGD",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheYearPicker,
        // TheInputTextSelect,
        TheCustomFilePicker,

        TheConfirmDialog,
        TheCheckboxConfirmDialog,
        TheDataImportShow,
        TheGetLocationButton,
        TheGetFileImportDialog,
    },

    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            modelRec: truongQGGDModel.newModel(),
            model: truongQGGDModel.newFEModel(),
            errors: truongQGGDModel.errors(),
            modelSearch: truongQGGDModel.newPagingSearchModel(),

            cEnable_Value: null,

            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,

            csList: [],
            csList_Code: null,
            checkEnable_Memo: false,
            sType_List: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),
            category_MUCTRUONGCHUANGD: [],
            category_QUYMOTRUONGCHUANGD: [],
            category_PHUONGXA: [],
            category_PHANLOAITRUONGCHUAN: [],
            category_CONGLAP: [],
            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,

            filesUpload: [],
            tempKey: common.randomString(10),

            titleImportData: [
                { columnId: 'tenTruong', columnTitle: 'Tên trường' },
                { columnId: 'vemisId', columnTitle: 'Vemis ID' },
                { columnId: 'truongId', columnTitle: 'Trường ID' },
                { columnId: 'congLap', columnTitle: 'Công lập' },
                { columnId: 'phanloaiTruongchuanId', columnTitle: 'Phân loại trường ID' },
                { columnId: 'soluongLop', columnTitle: 'Số lượng lớp' },
                { columnId: 'soluongGiaovien', columnTitle: 'Số lượng giáo viên' },
                { columnId: 'soluongHocsinh', columnTitle: 'Số lượng học sinh' },
                { columnId: 'soluongHocsinhNhapsodinhdanh', columnTitle: 'Số lượng học sinh định danh' },
                { columnId: 'mucTruongchuanId', columnTitle: 'Mức trường chuẩn ID' },
                { columnId: 'quymoTruongchuanId', columnTitle: 'Quy mô trường chuẩn ID' },
                { columnId: 'namThanhLap', columnTitle: 'Năm thành lập' },
                { columnId: 'namCongNhan', columnTitle: 'Năm công nhận' },
                { columnId: 'namSatNhap', columnTitle: 'Năm sát nhập' },
                { columnId: 'hieuTruong', columnTitle: 'Hiệu trưởng' },
                { columnId: 'sdtHieuTruong', columnTitle: 'Số điện thoại HT' },
                { columnId: 'phuongXaId', columnTitle: 'Phường xã' },
                { columnId: 'gpsLong', columnTitle: 'GPS Long' },
                { columnId: 'gpsLat', columnTitle: 'GPS Lat' },
                { columnId: 'gioiThieu', columnTitle: 'Giới thiệu' },
                { columnId: 'ghiChu', columnTitle: 'Ghi chú' },
                { columnId: 'stt', columnTitle: 'STT' },
                { columnId: 'enabled', columnTitle: 'Enabled' }
                // { columnId: 'iocEnabled', columnTitle: 'IOC Enabled' }
            ],

            import_MapModel: {
                title: "",
                confirmLabelButton: "",
                onClose: null,
                onSubmit: null,
                dataTitle: [],
                dataImport: [],
            },
            import_GetFileModel: {
                title: "",
                confirmLabelButton: "",
                onClose: null,
                onSubmit: null,
                filename: "",
                acceptFile: "",
                modelValue: [],
            },
            existsError: false,
            displayChangeSubmit: true,
        }
    },

    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData2', ['handleTypeImport',]),
        ...mapActions('truongQGGD', ['getPagingTruongQGGD', 'getDetailTruongQGGD', 'checkExistTruongQGGD', 'createTruongQGGD', 'updateTruongQGGD', 'deleteTruongQGGD', 'restoreTruongQGGD', 'handleListTruongQGGD', 'setEnabledTruongQGGD', 'setEnabledIOCTruongQGGD', 'exportExcelTruongQGGD', 'getMapInfoTruongQGGD', 'importExcelTruongQGGD']),
        ...mapActions('mucTruongChuanGD', ['getBasicMucTruongChuanGD']),
        ...mapActions('quyMoTruongChuanGD', ['getBasicQuyMoTruongChuanGD']),
        ...mapActions('phanLoaiTruongGD', ['getBasicPhanLoaiTruongGD']),
        ...mapActions('phuongXa', ['getsPhuongXa']),

        async setup() {
            let header = 'Danh sách Trường'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_MUCTRUONGCHUANGD = await this.getCategory_MucTruongChuanGD()
            this.category_QUYMOTRUONGCHUANGD = await this.getCategory_QuyMoTruongChuanGD()
            this.category_PHUONGXA = await this.getCategory_PhuongXa()
            this.category_PHANLOAITRUONGCHUAN = await this.getCategory_PhanLoaiTruongGD()
            this.category_CONGLAP = [{ id: 1, name: "Công Lập" }, { id: 0, name: "Tư Thục" }]
        },


        //#region NavigateModal
        async showModal() {
            $('#insUpdModal').modal('show')
        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },
        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
        },

        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.tempKey = common.randomString(10)
            $('#enabledConfirmModal').modal('show')
        },
        async hideEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('hide')
        },

        // async showIOCEnabledConfirmModal() {
        //     this.csListEnabled_MapModel = {
        //         title: "XÁC NHẬN",
        //         confirmLabelButton: "Xác nhận",
        //         onClose: this.closeConfirmIOCEnabledChange,
        //         onSubmit: this.updateIOCEnabled,
        //         submitArgs: [2],
        //         modalContent: "<label>Bạn có chắc chắn muốn thay đổi đồng bộ từ IOC tỉnh?</label>",
        //     }
        //     this.tempKey = common.randomString(10)
        //     $('#IOCenabledConfirmModal').modal('show')
        // },


        // async hideIOCEnabledConfirmModal() {
        //     $('#IOCenabledConfirmModal').modal('hide')
        // },
        async showImportModal() {
            this.import_GetFileModel = {
                title: "Import",
                confirmLabelButton: "Đọc dữ liệu file",
                onClose: this.hideImportModal,
                onSubmit: this.onImportSubmit,
                filename: "TruongChuanQG_ImportSample.xlsx",
                acceptFile: this.acceptTypeExcel,
                filesImport: [],
            }
            this.tempKey = common.randomString(10),
                $('#importModal').modal('show');
        },
        async hideImportModal() {
            $('#importModal').modal('hide');
        },
        async showPopupImportConfirm() {
            $('#importConfirmModal').modal('show')
        },
        async hidePopupImportConfirm() {
            $('#importConfirmModal').modal('hide')
        },
        //#endregion NavigateModal

        //#region NavigateInTable
        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }
        },

        async updateEnabled(from) {
            let model = {
                truongchuanQuocgiaId: this.cEnable_Value.truongchuanQuocgiaId,
                enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
            }
            await this.setEnabledTruongQGGD({ model: model }).then(resp => {
                if (resp) {
                    this.hideEnabledConfirmModal()
                }
                else {
                    this.hideEnabledConfirmModal()
                }
            });
        },

        // async openConfirmIOCEnabledChange(item) {
        //     if (!this.checkEnable_Memo) {
        //         this.cEnable_Value = item
        //         await this.showIOCEnabledConfirmModal()
        //     }
        //     else {
        //         this.cEnable_Value = item
        //         this.updateIOCEnabled(1)

        //     }
        // },

        // async updateIOCEnabled(from) {
        //     let model = {
        //         truongchuanQuocgiaId: this.cEnable_Value.truongchuanQuocgiaId,
        //         iocEnabled: from == 1 ? !this.cEnable_Value.iocEnabledDisplay : this.cEnable_Value.iocEnabledDisplay
        //     }
        //     await this.setEnabledIOCTruongQGGD({ model: model }).then(resp => {
        //         if (resp) {
        //             this.hideIOCEnabledConfirmModal()
        //         }
        //         else {
        //             this.hideIOCEnabledConfirmModal()
        //         }
        //     });
        // },


        async closeConfirmEnabledChange() {
            this.cEnable_Value.enabledDisplay = !this.cEnable_Value.enabledDisplay
            $('#item' + this.cEnable_Value.truongchuanQuocgiaId).prop('checked', this.cEnable_Value.enabledDisplay);
            await this.hideEnabledConfirmModal()
        },

        // async closeConfirmIOCEnabledChange() {
        //     this.cEnable_Value.iocEnabledDisplay = !this.cEnable_Value.iocEnabledDisplay
        //     $('#itemIOC' + this.cEnable_Value.truongchuanQuocgiaId).prop('checked', this.cEnable_Value.iocEnabledDisplay);
        //     await this.hideIOCEnabledConfirmModal()
        // },
        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },

        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.truongchuanQuocgiaId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        //#endregion NavigateInTable

        //#region NavigateSearch
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == this.typeDataList.DELETED_LIST.id) this.sType_List = this.typeDataList.CURRENT_LIST.id
            else if (this.sType_List == this.typeDataList.CURRENT_LIST.id) this.sType_List = this.typeDataList.DELETED_LIST.id
            await this.handlePageChange(1)
        },
        async onSelectSearchChange(e, typeChange) {
            if (typeChange == 'ENABLED') {
                switch (e) {
                    case "true":
                        this.modelSearch.enabled = true
                        break
                    case "false":
                        this.modelSearch.enabled = false
                        break
                    default:
                        this.modelSearch.enabled = null
                }
                this.handlePageChange(1)
                return
            }
            // if (typeChange == 'IOCENABLED') {
            //     switch (e) {
            //         case "true":
            //             this.modelSearch.truongId = true
            //             break
            //         case "false":
            //             this.modelSearch.truongId = false
            //             break
            //         default:
            //             this.modelSearch.truongId = null
            //     }
            //     this.handlePageChange(1)
            //     return
            // }
            if (typeChange == 'PHUONGXA') {
                this.modelSearch.phuongXaId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'MUCTRUONGCHUAN') {
                this.modelSearch.mucTruongchuanId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'QUYMOTRUONGCHUAN') {
                this.modelSearch.quymoTruongchuanId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'LOAIHINHTRUONG') {
                this.modelSearch.phanloaiTruongchuanId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
            if (typeChange == 'PHANLOAITRUONG') {
                this.modelSearch.phanloaiTruongchuanId = e == "" ? null : e
                this.handlePageChange(1)
                return
            }

            if (typeChange == 'CONGLAP') {
                this.modelSearch.congLap = e == "" ? null : e
                this.handlePageChange(1)
                return
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            if (this.modelSearch.tenTruong == "") this.modelSearch.tenTruong = null
            if (this.modelSearch.truongId == "") this.modelSearch.truongId = null
            if (this.modelSearch.vemisId == "") this.modelSearch.vemisId = null
        },

        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()

            await this.getPagingTruongQGGD({ params: this.modelSearch, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                        this.items[i].iocEnabledDisplay = this.items[i].iocEnabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        //#endregion NavigateSearch

        //#region NavigateMap
        async openMap() {
            let params = {
            }
            let res = await this.getMapInfoTruongQGGD({ params: params })
            if (res) {
                let tableID = res[0].tableId ? res[0].tableId : null
                let loaiDiadiemId = (res[0].loaiDiadiemId != undefined) ? res[0].loaiDiadiemId.toString() : null
                let phanloaiDiadiemId = (res[0].phanloaiDiadiemId != undefined) ? res[0].phanloaiDiadiemId.toString() : null
                if (tableID || loaiDiadiemId || phanloaiDiadiemId) {
                    let link = config.QUYHOACH_PAGE + "AppCongDan/MapTienIch?"
                    link = tableID ? link + "tableId=" + tableID : link
                    link = loaiDiadiemId ? link + "&loaiDiadiemId=" + loaiDiadiemId : link
                    link = phanloaiDiadiemId ? link + "&phanloaiDiadiemId=" + phanloaiDiadiemId : link
                    window.open(link, "_blank");
                }
                else {
                    this.$store.dispatch("alert/error", "Lấy thông tin bản đồ thất bại!", { root: true });
                }

            }
        },

        async openDetailMap(detailID) {
            let params = {
            }
            let res = await this.getMapInfoTruongQGGD({ params: params })
            if (res) {
                let tableID = res[0].tableId ? res[0].tableId : null
                let loaiDiadiemId = (res[0].loaiDiadiemId != undefined) ? res[0].loaiDiadiemId.toString() : null
                let phanloaiDiadiemId = (res[0].phanloaiDiadiemId != undefined) ? res[0].phanloaiDiadiemId.toString() : null
                if (tableID || loaiDiadiemId || phanloaiDiadiemId) {
                    let link = config.QUYHOACH_PAGE + "AppCongDan/MapTienIch?"
                    link = tableID ? link + "tableId=" + tableID : link
                    link = loaiDiadiemId ? link + "&loaiDiadiemId=" + loaiDiadiemId : link
                    link = phanloaiDiadiemId ? link + "&phanloaiDiadiemId=" + phanloaiDiadiemId : link
                    link = detailID ? link + "&detailId=" + detailID : link
                    window.open(link, "_blank");
                }
                else {
                    this.$store.dispatch("alert/error", "Lấy thông tin bản đồ thất bại!", { root: true });
                }
            }
        },
        //#endregion NavigateMap

        //#region CUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = truongQGGDModel.errors()

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    truongchuanQuocgiaId: item.truongchuanQuocgiaId
                }
                let resp = await this.getDetailTruongQGGD({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = truongQGGDModel.newModel()
                        this.modelRec = resp
                        this.model = truongQGGDModel.parseModeltoFEModel(this.modelRec)
                        //this.triggerDetail()
                        let fHinhAnh = [{
                            fileId: this.modelRec.hinhAnh,
                            fileName: this.modelRec.tenFileHinhAnh,
                            downloadLink: this.modelRec.linkHinhAnh,
                        }]
                        this.filesUpload = this.modelRec.hinhAnh ? JSON.parse(JSON.stringify(fHinhAnh)) : [];
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.displayChangeSubmit = true
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    truongchuanQuocgiaId: item.truongchuanQuocgiaId
                }
                await this.getDetailTruongQGGD({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = truongQGGDModel.newModel()
                        this.modelRec = resp
                        if (this.modelRec.gioiThieu) {
                            let contentDiv = document.getElementById('gioiThieu_Detail');
                            contentDiv.innerHTML = this.modelRec.gioiThieu;
                        }
                        else {
                            let contentDiv = document.getElementById('gioiThieu_Detail');
                            contentDiv.innerHTML = '';
                        }
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = truongQGGDModel.newFEModel()
                this.filesUpload = []
                this.isReadOnly = (code == this.navigateCode.CREATE) ? false : true
                this.model.enabledDisplay = true
                this.model.stt = "0"
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistTruongQGGD({ params: params })
            return res.data

        },
        async validate(model) {
            let isvalid = true
            this.errors = truongQGGDModel.errors()
            if (!await this.validateRequired(model.tenTruong)) {
                this.errors.ten = "Nhập tên"
                isvalid = false
            }
            else if (this.code == this.navigateCode.UPDATE && this.modelRec.tenTruong != model.tenTruong) {
                if (await this.checkExistName(model.tenTruong)) {
                    this.errors.tenTruong = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == this.navigateCode.CREATE) {
                if (await this.checkExistName(model.tenTruong)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.mucTruongchuanId)) {
                this.errors.mucTruongchuanId = "Chọn mức trường chuẩn"
                isvalid = false
            }

            if (!await this.validateRequired(model.quymoTruongchuanId)) {
                this.errors.quymoTruongchuanId = "Chọn quy mô trường chuẩn"
                isvalid = false
            }

            if (!await this.validateRequired(model.phanloaiTruongchuanId)) {
                this.errors.phanloaiTruongchuanId = "Chọn phân loại trường"
                isvalid = false
            }

            if (!await this.validateRequired(model.phuongXaId)) {
                this.errors.phuongXaId = "Chọn phường xã"
                isvalid = false
            }

            if (!await this.validateNumber(model.soluongLop)) {
                this.errors.soluongLop = "Số lớp phải là kiểu số"
                isvalid = false
            }
            if (!await this.validateNumber(model.soluongGiaovien)) {
                this.errors.soluongGiaovien = "Số giáo viên phải là kiểu số"
                isvalid = false
            }
            if (!await this.validateNumber(model.soluongHocsinh)) {
                this.errors.soluongHocsinh = "Số học sinh phải là kiểu số"
                isvalid = false
            }
            if (!await this.validateNumber(model.soluongHocsinhNhapsodinhdanh)) {
                this.errors.soluongHocsinhNhapsodinhdanh = "Số học sinh định danh phải là kiểu số"
                isvalid = false
            }




            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = truongQGGDModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.truongchuanQuocgiaId = FEmodel.truongchuanQuocgiaId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.truongchuanQuocgiaId = FEmodel.truongchuanQuocgiaId
                sendModel.tenTruong = FEmodel.tenTruong
                sendModel.truongId = FEmodel.truongId == "" ? null : FEmodel.truongId
                sendModel.hieuTruong = FEmodel.hieuTruong
                sendModel.sdtHieuTruong = FEmodel.sdtHieuTruong
                sendModel.mucTruongchuanId = FEmodel.mucTruongchuanId == "" ? null : FEmodel.mucTruongchuanId
                sendModel.namCongNhan = FEmodel.namCongNhan
                sendModel.quymoTruongchuanId = FEmodel.quymoTruongchuanId == "" ? null : FEmodel.quymoTruongchuanId
                sendModel.namSatNhap = FEmodel.namSatNhap
                sendModel.vemisId = FEmodel.vemisId == "" ? null : FEmodel.vemisId
                sendModel.namThanhLap = FEmodel.namThanhLap
                sendModel.gpsLong = FEmodel.gpsLong
                sendModel.gpsLat = FEmodel.gpsLat
                sendModel.phanloaiTruongchuanId = FEmodel.phanloaiTruongchuanId
                sendModel.congLap = FEmodel.congLap == "" ? null : FEmodel.congLap
                sendModel.phuongXaId = FEmodel.phuongXaId
                sendModel.gioiThieu = FEmodel.gioiThieu


                if (!FEmodel.soluongLop || FEmodel.soluongLop == "") {
                    sendModel.soluongLop = 0
                } else sendModel.soluongLop = FEmodel.soluongLop

                if (!FEmodel.soluongGiaovien || FEmodel.soluongGiaovien == "") {
                    sendModel.soluongGiaovien = 0
                } else sendModel.soluongGiaovien = FEmodel.soluongGiaovien

                if (!FEmodel.soluongHocsinh || FEmodel.soluongHocsinh == "") {
                    sendModel.soluongHocsinh = 0
                } else sendModel.soluongHocsinh = FEmodel.soluongHocsinh

                if (!FEmodel.soluongHocsinhNhapsodinhdanh || FEmodel.soluongHocsinhNhapsodinhdanh == "") {
                    sendModel.soluongHocsinhNhapsodinhdanh = 0
                } else sendModel.soluongHocsinhNhapsodinhdanh = FEmodel.soluongHocsinhNhapsodinhdanh

                sendModel.ghiChu = FEmodel.ghiChu
                //sendModel.iocId = FEmodel.iocId
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
                sendModel.iocEnabled = FEmodel.iocEnabledDisplay ? FEmodel.iocEnabledDisplay : false

                if (this.code == this.navigateCode.CREATE) {
                    if (this.filesUpload && this.filesUpload.length > 0) {
                        sendModel.fHinhAnh = this.filesUpload[0]
                    }
                    else sendModel.fHinhAnh = null
                }
                else if (this.code == this.navigateCode.UPDATE) {
                    if (FEmodel.tenFileHinhAnh) {
                        //Có sẵn file
                        if (this.filesUpload && this.filesUpload.length > 0) {
                            if (FEmodel.tenFileHinhAnh == this.filesUpload[0].name) {
                                //Khong thay đổi file
                                sendModel.fHinhAnh = null
                                sendModel.xoaHinhAnh = false
                            }
                            else {
                                //Thay đổi file
                                sendModel.fHinhAnh = this.filesUpload[0]
                            }
                        }
                        else {
                            //Xóa file
                            sendModel.fHinhAnh = null
                            sendModel.xoaHinhAnh = true
                        }

                    }
                    else {
                        //Không có file
                        if (this.filesUpload && this.filesUpload.length > 0) {
                            sendModel.fHinhAnh = this.filesUpload[0]
                        }
                        else {
                            sendModel.fHinhAnh = null
                        }
                    }
                }
            }
            return sendModel
        },
        async onSubmit() {
            let code = this.code
            this.displayChangeSubmit = false
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createTruongQGGD({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateTruongQGGD({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteTruongQGGD({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteTruongQGGD({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreTruongQGGD({ model: sendModel })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hideModal()
            }
            this.displayChangeSubmit = true
        },
        //#endregion CUD

        //#region NavigateMultipleInTable
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                this.csList_MapModel = {
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: this.hidePopupconfirmcsListModal,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.showPopupconfirmcsListModal()
            }
        },
        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            // if (code == this.navigateCode.ON_IOC_ENABLED) {
            //     modelSend.model.enabled = false
            // }
            // if (code == this.navigateCode.OFF_IOC_ENABLED) {
            //     modelSend.model.enabled = true
            // }
            let res = null
            res = await this.handleListTruongQGGD(modelSend)
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.hidePopupconfirmcsListModal()
            }
        },
        //#endregion NavigateMultipleInTable

        //#region handleExcel
        async exportExcel() {
            await this.standardizationFilter()
            let params = truongQGGDModel.newSearchModel(this.modelSearch)
            await this.exportExcelTruongQGGD({ params: params }).then(res => {
                if (res) {
                    let header = [
                        'ID',
                        'Tên trường',
                        'Vemis ID',
                        'Trường ID',
                        'Công lập',
                        'Phân loại trường chuẩn ID',
                        'Tên phân loại',
                        'Số lớp',
                        'Số giáo viên',
                        'Số học sinh',
                        'Số học sinh đã định danh',
                        'Mức trường chuẩn ID',
                        'Tên mức trường chuẩn',
                        'Quy mô trường chuẩn ID',
                        'Tên quy mô trường chuẩn',
                        'Phường xã ID',
                        'Tên Phường xã',
                        'Năm thành lập',
                        'Năm công nhận',
                        'Năm sát nhập',
                        'Hiệu trưởng',
                        'Số điện thoại Hiệu trưởng',
                        'GPS Long',
                        'GPS Lat',
                        //'Giới thiệu',
                        'Ghi chú',
                        'Số thứ tự',
                        'Enabled',
                        // 'IOC ID',
                        // 'IOC Enabled',
                        // 'Ngày upadate IOC',
                    ]
                    const formattedData = res.map(item => {
                        return {
                            'ID': item.truongchuanQuocgiaId,
                            'Tên trường': item.tenTruong,
                            'Vemis ID': item.vemisId,
                            'Trường ID': item.truongId,
                            'Công lập': item.congLap,
                            'Phân loại trường chuẩn ID': item.phanloaiTruongchuanId,
                            'Tên phân loại': item.tenPhanloaiTruongchuan,
                            'Số lớp': item.soluongLop,
                            'Số giáo viên': item.soluongGiaovien,
                            'Số học sinh': item.soluongHocsinh,
                            'Số học sinh đã định danh': item.soluongHocsinhNhapsodinhdanh,
                            'Mức trường chuẩn ID': item.mucTruongchuanId,
                            'Tên mức trường chuẩn': item.tenMucTruongchuan,
                            'Quy mô trường chuẩn ID': item.quymoTruongchuanId,
                            'Tên quy mô trường chuẩn': item.tenQuymoTruongchuan,
                            'Phường xã ID': item.phuongXaId,
                            'Tên Phường xã': item.tenPhuongXa,
                            'Năm thành lập': item.namThanhLap,
                            'Năm công nhận': item.namCongNhan,
                            'Năm sát nhập': item.namSatNhap,
                            'Hiệu trưởng': item.hieuTruong,
                            'Số điện thoại Hiệu trưởng': item.sdtHieuTruong,
                            'GPS Long': item.gpsLong,
                            'GPS Lat': item.gpsLat,
                            //'Giới thiệu': item.gioiThieu,
                            'Ghi chú': item.ghiChu,
                            'Số thứ tự': item.stt,
                            'Enabled': item.enabled,
                            // 'IOC ID': item.iocId,
                            // 'IOC Enabled': item.iocEnabled,
                            // 'Ngày upadate IOC': item.iocDateUpdated,
                        };
                    });
                    const ws = utils.json_to_sheet(formattedData, { header: header });
                    const wb = utils.book_new();
                    utils.book_append_sheet(wb, ws, "Data");
                    writeFileXLSX(wb, "Export_Truong.xlsx");
                }

            });
        },

        async onImportSubmit() {
            if (this.import_GetFileModel.filesImport[0]) {

                await this.handleImportData(this.import_GetFileModel.filesImport[0]).then(results => {
                    this.hideImportModal()
                    if (results) {
                        this.import_MapModel = {
                            title: "Xác nhận Import",
                            confirmLabelButton: "Xác nhận",
                            onClose: this.hidePopupImportConfirm,
                            onSubmit: this.onConfirmImportSubmit,
                            displaySubmit: !this.existsError,
                            dataTitle: this.titleImportData,
                            dataImport: this.listDataImport,
                        }
                        console.log(this.listDataImport)
                        this.tempKey = common.randomString(10)

                        this.showPopupImportConfirm()
                    }
                    else {
                        this.$store.dispatch("alert/error", "Có lỗi trong quá trình xử lý dữ liệu Import!", { root: true });
                    }
                });
            }
            else {
                this.$store.dispatch("alert/warning", "Vui lòng chọn tập tin để Import!", { root: true });
            }
        },
        async handleImportData(file) {
            this.existsError = false;
            this.listDataImport = [];
            if (file) {
                try {
                    const result = await this.readFileAsBinaryString(file); // Read file as binary string
                    /* Parse data */
                    const wb = read(result, { type: 'binary' });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data = utils.sheet_to_json(ws, { header: 1 });
                    const filteredData = [];

                    // Filter data for non-empty rows and add rowNumber
                    data.forEach((row, index) => {
                        if (row.some(cell => cell !== '' && cell !== null && cell !== undefined)) {
                            row.rowNumber = index + 1; // Add rowNumber to each row
                            filteredData.push(row);
                        }
                    });
                    filteredData.splice(0, 1); // Remove header row

                    // Process each row of data
                    for (const element of filteredData) {
                        let import_DATA = {};
                        import_DATA.tenTruong = await this.handleTypeImport({ input: element[0], typeData: objectDefaultValue.handleData.STRING, required: true });
                        import_DATA.vemisId = await this.handleTypeImport({ input: element[1], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.truongId = await this.handleTypeImport({ input: element[2], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.congLap = await this.handleTypeImport({ input: element[3], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.phanloaiTruongchuanId = await this.handleTypeImport({ input: element[4], typeData: objectDefaultValue.handleData.INT, required: true });
                        import_DATA.soluongLop = await this.handleTypeImport({ input: element[5], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.soluongGiaovien = await this.handleTypeImport({ input: element[6], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.soluongHocsinh = await this.handleTypeImport({ input: element[7], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.soluongHocsinhNhapsodinhdanh = await this.handleTypeImport({ input: element[8], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.mucTruongchuanId = await this.handleTypeImport({ input: element[9], typeData: objectDefaultValue.handleData.INT, required: true });
                        import_DATA.quymoTruongchuanId = await this.handleTypeImport({ input: element[10], typeData: objectDefaultValue.handleData.INT, required: true });
                        import_DATA.namThanhLap = await this.handleTypeImport({ input: element[11], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.namCongNhan = await this.handleTypeImport({ input: element[12], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.namSatNhap = await this.handleTypeImport({ input: element[13], typeData: objectDefaultValue.handleData.INT, required: false });
                        import_DATA.hieuTruong = await this.handleTypeImport({ input: element[14], typeData: objectDefaultValue.handleData.STRING, required: false });
                        import_DATA.sdtHieuTruong = await this.handleTypeImport({ input: element[15], typeData: objectDefaultValue.handleData.STRING, required: false });
                        import_DATA.phuongXaId = await this.handleTypeImport({ input: element[16], typeData: objectDefaultValue.handleData.INT, required: true });
                        import_DATA.gpsLong = await this.handleTypeImport({ input: element[17], typeData: objectDefaultValue.handleData.STRING, required: false });
                        import_DATA.gpsLat = await this.handleTypeImport({ input: element[18], typeData: objectDefaultValue.handleData.STRING, required: false });
                        import_DATA.gioiThieu = await this.handleTypeImport({ input: element[19], typeData: objectDefaultValue.handleData.STRING, required: false });
                        import_DATA.ghiChu = await this.handleTypeImport({ input: element[20], typeData: objectDefaultValue.handleData.STRING, required: false });
                        import_DATA.stt = await this.handleTypeImport({ input: element[21], typeData: objectDefaultValue.handleData.INT, required: true });
                        import_DATA.enabled = await this.handleTypeImport({ input: element[22], typeData: objectDefaultValue.handleData.BOOLEAN, required: true });

                        // Check if there's an error in the data
                        if (!this.existsError) {
                            for (let key in import_DATA) {
                                if (import_DATA[key].isError === true) {
                                    this.existsError = true;
                                    break;
                                }
                            }
                        }

                        // Prepare and add data to the list
                        let insertData = {
                            rowIndex: element.rowNumber ? element.rowNumber : null,
                            data: import_DATA
                        };
                        this.listDataImport.push(insertData);
                    }

                    return true;  // Data processed successfully
                } catch (error) {
                    console.error("Error processing the file: ", error);
                    return false; // Error in processing the file
                }
            } else {
                console.warn("No file selected for import.");
                return false; // No file selected
            }
        },

        // Helper method to read file as binary string using Promises
        async readFileAsBinaryString(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (e) => reject(e);
                reader.readAsBinaryString(file);
            });
        },

        async onConfirmImportSubmit() {
            if (!this.existsError) {
                let listData = []
                for (const element of this.listDataImport) {
                    let tempValue = Object()
                    for (let key in element.data) {
                        if (element.data[key].value != "")
                            tempValue[key] = element.data[key].value
                    }
                    listData.push(tempValue);
                }

                //re-fix data
                for (let i = 0; i < listData.length; i++) {
                    if (!listData[i].soluongLop) listData[i].soluongLop = '0'
                    if (!listData[i].soluongGiaovien) listData[i].soluongGiaovien = '0'
                    if (!listData[i].soluongHocsinh) listData[i].soluongHocsinh = '0'
                    if (!listData[i].soluongHocsinhNhapsodinhdanh) listData[i].soluongHocsinhNhapsodinhdanh = '0'
                }
                let importPush = {
                    listData: listData,
                };
                let result = await this.importExcelTruongQGGD({ item: importPush })
                this.hidePopupImportConfirm()
                if (result === true)
                    await this.getData();
            }
            else {
                alert("Giữ liệu đầu vào không phù hợp.");
            }
        },
        //#endregion handleExcel


        //#region getCategory
        async getCategory_MucTruongChuanGD() {
            let params = {
            }
            let res = await this.getBasicMucTruongChuanGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].mucTruongchuanId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_QuyMoTruongChuanGD() {
            let params = {
                tableId: 54
            }
            let res = await this.getBasicQuyMoTruongChuanGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].quymoTruongchuanId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_PhanLoaiTruongGD() {
            let params = {
            }
            let res = await this.getBasicPhanLoaiTruongGD({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phanloaiTruongchuanId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },



        async getCategory_PhuongXa() {
            let params = {
                quanHuyenId: config.QUANHUYEN_SITEID
            }
            let res = await this.getsPhuongXa({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phuongXaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        //#endregion getCategory

    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }


}
</script>
<style></style>